import { useEffect, useState } from 'react';
import { api, type Me } from './api.js';

let cached: Promise<Me | null> | null = null;

/** The signed-in person, from one /me call per page load (null until loaded, or if it fails). */
export function loadMe(): Promise<Me | null> {
  cached ??= api.me().catch(() => null);
  return cached;
}

export function useMe(): Me | null {
  const [me, setMe] = useState<Me | null>(null);
  useEffect(() => {
    let live = true;
    void loadMe().then((m) => live && setMe(m));
    return () => {
      live = false;
    };
  }, []);
  return me;
}
